import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import englishTranslations from '../public/translations/en.json';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  compatibilityJSON: 'v3',
  resources: {
    en: {
      translation: englishTranslations,
    },
  },
});

export default i18n;
